import classNames from 'classnames'
import * as SiteWideStyles from '../../../../../styles/abstract/SiteWide.css'
import * as HeaderNavigationSubMenuRecommendItemStyles from '../../../../../styles/foundation/HeaderNavigationSubMenuRecommendItem.css'
import { LocalizedLink } from '../../../../ui/v2/LocalizedLink'

type HeaderNavigationSubMenuRecommendItemProps = {
  entity: Queries.Hygraph_GlobalNavigationRecommendItem
}

export const HeaderNavigationSubMenuRecommendItem = ({ entity }: HeaderNavigationSubMenuRecommendItemProps) => {
  return (
    <article className={HeaderNavigationSubMenuRecommendItemStyles.Container}>
      <LocalizedLink
        to={entity.link}
        {...(entity.isBlank && { target: '_blank' })}
        rel="noopener"
        aria-label={`「${entity.title}」詳細ページへのリンク`}
        className={HeaderNavigationSubMenuRecommendItemStyles.Image}
      >
        <img src={entity.thumbnail.url} alt="" />
      </LocalizedLink>

      <div className={HeaderNavigationSubMenuRecommendItemStyles.Content}>
        {entity.subTitle && <div className={HeaderNavigationSubMenuRecommendItemStyles.Eyebrow}>{entity.subTitle}</div>}
        <h2 className={HeaderNavigationSubMenuRecommendItemStyles.Headline}>{entity.title}</h2>
        {entity.summary && <p className={HeaderNavigationSubMenuRecommendItemStyles.Summary}>{entity.summary}</p>}
        <LocalizedLink
          to={entity.link}
          {...(entity.isBlank && { target: '_blank' })}
          rel="noopener"
          className={classNames(
            HeaderNavigationSubMenuRecommendItemStyles.Button,
            SiteWideStyles.Button({ color: 'primary', mobileSize: 'small' })
          )}
        >
          {entity.buttonLabel}
        </LocalizedLink>
      </div>
    </article>
  )
}
